<template>
  <ShallowCard
    :class="{'cursor-pointer': !disabled}"
    :no-hover="disabled || noHover"
  >
    <div
      v-if="disabled"
      data-testid="accordion-header"
      class="flex flex-row grow items-center justify-between"
    >
      <span class="text-lg text-gray-900">{{ title }}</span>
      <FaIcon
        name="arrow-right"
        class="opacity-75"
        size="lg"
      />
    </div>

    <ElCollapse
      v-else
      v-model="active"
      class="el-collapse--plain"
    >
      <ElCollapseItem :name="NAME">
        <template #title="{ isActive }">
          <div class="flex flex-row grow items-center justify-between">
            <h5
              class="text-gray-900 mb-0"
              v-text="title"
            />
            <FaIcon
              name="arrow-right"
              variant="light"
              size="lg"
              class="transition-all duration-300 text-gray-700"
              :rotation="isActive ? '90' : undefined"
            />
          </div>
        </template>
        <!-- Die Stelle stellt ihren Pfeil selbst. Ein leerer `#icon`-Slot reicht
             nicht: EP fällt dann auf sein eigenes Icon zurück. -->
        <template #icon>
          <span class="hidden" />
        </template>
        <div
          class="overflow-auto"
          :class="`max-h-[${maxHeight}]`"
        >
          <slot />
        </div>
      </ElCollapseItem>
    </ElCollapse>
  </ShallowCard>
</template>

<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElCollapse, ElCollapseItem } from 'element-plus';
import { ref, watch } from 'vue';

import ShallowCard from '@/contracts/components/ShallowCard.vue';

interface Props {
  title: string,
  maxHeight?: string,
  disabled?: boolean,
  open?: boolean,
  noHover?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
  maxHeight: '200px',
});

const NAME = 'body';

const active = ref<string[]>(props.open ? [NAME] : []);

watch(() => props.open, (open) => {
  active.value = open ? [NAME] : [];
});
</script>
